let freezerConfig: FreezerConfig = {
    cabinetTransLayout: true,
    keyMap: {
        width: 'cubeData.width',
        height: 'cubeData.height',
        legHeight: 'cubeData.legHeight',
        depth: 'cubeData.depth',
        posX: 'cubeData.posX',
        posY: 'cubeData.posY',
        posZ: 'cubeData.posZ',
        id: 'cubeData.id',
        status: 'cubeData.status',
        created: 'cubeData.created',
        modified: 'cubeData.modified',
        yn: 'cubeData.yn',
        displayUnit: 'parentCubeData.displayUnit',
        shelfId: 'parentCubeData.id',
        serialNumber: 'cubeData.serialNumber',
        shelvesId: 'cubeData.shelvesId',
        name: 'cubeData.name',
        positionType: 'cubeData.positionType',
        specialAttr: "cubeData.specialAttr",
        shelvesGroupCode: "parentCubeData.shelvesGroupCode",
        warningEnumSet: "cubeData.warningEnumSet"
    }
};

export default freezerConfig;
